import React from 'react';

import VisuallyHidden from 'components/VisuallyHidden';

import StepperItem from './StepperItem';
import * as Styled from './styled';

/**
 * Stepper component props minimum required interface
 */
export type StepperProps = {
  /**
   * Steps to render
   */
  items: string[];
  /**
   * name of the given active step to highlight
   */
  activeStepName: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Stepper: React.FC<StepperProps> = ({ items, activeStepName }) => {
  const activeStepIndex = items.findIndex(name => name === activeStepName);
  const height = (items.length - 1) * 69 + 25;
  return (
    <Styled.Wrapper>
      <Styled.Box>
        <Styled.StepsLineContainer height={height}>
          <Styled.StepLine />
        </Styled.StepsLineContainer>
        <VisuallyHidden as='h2'>Progress indicator</VisuallyHidden>
        <Styled.ListContainer>
          {items.map((name, index) => (
            <StepperItem
              key={`${index}_${name}`}
              index={index}
              name={name}
              mode={
                index === activeStepIndex ? 'Current' : index < activeStepIndex ? 'Past' : 'Future'
              }
            />
          ))}
        </Styled.ListContainer>
      </Styled.Box>
    </Styled.Wrapper>
  );
};

export default React.memo(Stepper);
